<template>
    <brick-octagon-base>
        <template #icon>
            <component :is="iconSvg" />
        </template>
        
        <template #content-bottom>
            <div class="brick-title">
                {{displayName}}
            </div>
        </template>
    </brick-octagon-base>
</template>

<script>
    import {getBrickIconSvg} from "@modules/JourneyBuilder/Bricks/brick-icons";
    import BrickOctagonBase from "@modules/JourneyBuilder/Components/Patterns/BrickOctagonBase.vue";

    export default {
        name: 'menu-composable-octagon-bricks',
        components: {
            BrickOctagonBase
        },
        computed: {
            iconSvg(){
                return getBrickIconSvg(this.brickType);
            }
        },
        props: {
            displayName: {
                type: String,
                required: true
            },
            brickType: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/composable-octagon-brick.scss";
</style>
